import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {map} from "rxjs/operators";

const routes = {
    filter: `/config-general/getDetailConfigGeneral`,
    create: `/config-general/create`,
    keyConfig: `/key-config/get-all`,
};

@Injectable({
    providedIn: 'root'
})

export class ConfigGeneralManageService {
    constructor(
        private apiService: ApiService
    ) {
    }

    getAllKeyConfig(){
      return this.apiService.get(routes.keyConfig).pipe(map(res => {
        return res;
      }));
    }

    createConfigGeneral(serviceType: any, errCallback?: any) {
        return this.apiService.post(routes.create, serviceType)
            .pipe(map(res => {
                    if (errCallback && !res.success) {
                        errCallback(res);
                    }
                    return res;
                }
            ));
    }

    filterConfigGeneral(errCallback?: any) {
        return this.apiService.post(routes.filter)
            .pipe(map(response => {
                    if (errCallback && !response.success) errCallback(response);
                    return response;
                }
            ));
    }

  createConfigGeneralAdmin(serviceType: any, errCallback?: any) {
    return this.apiService.post(`/config-general/create-admin`, serviceType)
      .pipe(map(data => {
          if (errCallback && !data.success) {
            errCallback(data);
          }
          return data;
        }
      ));
  }

  filterConfigGeneralAdmin(errCallback?: any) {
    return this.apiService.post(`/config-general/getDetailConfigGeneralAdmin`)
      .pipe(map(response => {
          if (errCallback && !response.success) errCallback(response);
          return response;
        }
      ));
  }

}
